module.exports = __webpack_public_path__ + "img/sad.dc554a5f.png";